<template>
  <el-dialog :title="title" width="60%" :visible.sync="rejectDialog" :close-on-click-modal="false">
    <table
      v-loading.fullscreen.lock="fullscreenLoading"
      cellspacing="0"
      cellpadding="0"
      border="0"
      class="form-table"
    >
      <tbody>
        <tr>
          <th style="width: 140px;">
            <span class="xh-star">*</span>驳回重提模式：
          </th>
          <td>
            <el-radio v-model="backHandMode" label="direct">回到本节点</el-radio>
            <el-radio v-model="backHandMode" label="normal">重新审批</el-radio>
            <span v-show="false" class="xh-star">(网关内驳回只能回到本节点)</span>
          </td>
        </tr>

        <tr>
          <th style="width: 140px;">
            <span class="xh-star">*</span>驳回方式：
          </th>
          <td style="height: 50px;line-height: 25px;">
            <el-radio
              v-model="radio"
              label="backToStart"
              v-show="rejectConf.canRejectToStart && (backHandMode =='normal' || !rejectConf.inSubProcess)"
            >驳回发起人</el-radio>
            <el-radio
              v-model="radio"
              v-if="!rejectConf.afterGateway && !rejectConf.inGateway && !rejectConf.inSubProcess"
              label="rejectPre"
              v-show="rejectConf.canRejectPreAct"
            >驳回上一步</el-radio>
            <el-radio
              v-model="radio"
              label="reject"
              v-show="rejectConf.canRejectToAnyNode && (!rejectConf.inSubProcess || backHandMode !='normal' )"
            >驳回指定节点</el-radio>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-select
              style="width: 130px;"
              size="mini"
              v-show=" rejectConf.canRejectToAnyNode && radio == 'reject' "
              v-model="nodeId"
              placeholder="请选择"
            >
              <el-option
                v-for="bpmExeStack in canRejectNode"
                :key="bpmExeStack.nodeId"
                :label="bpmExeStack.name"
                :value="bpmExeStack.nodeId"
              ></el-option>
            </el-select>
          </td>
        </tr>

        <tr v-show="!opinion">
          <th style="width: 140px;">
            <span class="xh-star">*</span>驳回意见：
          </th>
          <td colspan="3">
            <OpinionText ref="opinionText" :text="opinion" />
          </td>
        </tr>
        <tr>
          <th style="width: 140px;">附件上传：</th>
          <td colspan="3">
            <FileUpload ref="fileUpload" />
          </td>
        </tr>
      </tbody>
    </table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm" size="small" :loading="rejectSubmitLoading">确 定</el-button>
      <el-button @click="cancel" size="small">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Message } from "element-ui";
import OpinionText from "@/components/common/opinionText.vue";
import FileUpload from "@/components/common/fileUpload.vue";
import utils from "@/utils.js";

export default { 
  name: "taskToReject",
  props: ["taskId", "leaderId", "opinion"],
  components: { OpinionText, FileUpload },
  data() {
    return {
      rejectSubmitLoading:false,
      rejectTaskId:"",//要驳回的任务ID
      rejectDialog: false,
      radio: "",
      nodeId: "",
      backHandMode: "direct",
      token: utils.getUrlKey("token"),
      canRejectNode: [],
      rejectConf: {},
      isSameNode: true,
      title: "驳回",
      fullscreenLoading: true
    };
  },
  computed: {},
  watch: {
    backHandMode: function(n, o) {
      if (this.rejectConf.inSubProcess) {
        if (n == "normal") {
          this.radio = "backToStart";
        } else {
          this.radio = "reject";
        }
      }
      if (!this.isSameNode) {
        if (n == "normal") {
          this.canRejectNode = this.rejectConf.allowNormalNode;
        } else {
          this.canRejectNode = this.rejectConf.allowDirectNode;
        }
        let flag = false;
        this.canRejectNode.forEach(n => {
          if (n.nodeId == this.nodeId) {
            flag = true;
            return;
          }
        });
        if (!flag) {
          this.nodeId = "";
        }
      }
    }
  },
  methods: {
    //鼠标点击页面其他其他位置不关闭弹框
    handleClose() {
      this.rejectDialog = true;
    },
    //打开驳回设置页面
    handleOpen(parentTaskId) {
      if(parentTaskId){
        this.rejectTaskId = parentTaskId;
      }
      let data = { taskId: this.taskId, backModel: "reject" };
      let this_ = this;
      this.$store
        .dispatch("storeProcess/taskToReject", data)
        .then(function(resp) {
          this_.rejectConf = resp;
          let normalNodeIds = [];
          resp.allowNormalNode.forEach(element => {
            normalNodeIds.push(element.nodeId);
          });
          if (resp.allowNormalNode) {
            resp.allowDirectNode.forEach(element => {
              if (normalNodeIds.indexOf(element.nodeId) < 0) {
                this_.isSameNode = false;
              }
            });
          }
          if (resp.inGateway) {
            this_.backHandMode = "direct";
          }
          if (this_.backHandMode == "normal") {
            this_.canRejectNode = resp.allowNormalNode;
          } else {
            this_.canRejectNode = resp.allowDirectNode;
          }

          // 只有驳回发起人的情况
          if (
            this_.rejectConf.canRejectToStart &&
            !this_.rejectConf.canRejectPreAct &&
            !this_.rejectConf.canRejectToAnyNode
          ) {
            this_.radio = "backToStart";
            this_.confirm();
            this_.fullscreenLoading = false;
            return;
          }
          // 只有驳回上一步的情况
          if (
            !this_.rejectConf.canRejectToStart &&
            this_.rejectConf.canRejectPreAct &&
            !this_.rejectConf.canRejectToAnyNode
          ) {
            this_.radio = "rejectPre";
            this_.confirm();
            this_.fullscreenLoading = false;
            return;
          }

          // 只有驳回指定节点的情况并且指定节点只有一个
          if (
            !this_.rejectConf.canRejectToStart &&
            !this_.rejectConf.canRejectPreAct &&
            this_.rejectConf.canRejectToAnyNode &&
            this_.canRejectNode.length == 1
          ) {
            this_.nodeId = this_.canRejectNode[0].nodeId;
            this_.radio = "reject";
            this_.confirm();
            this_.fullscreenLoading = false;
            return;
          }
          if(this_.rejectConf.canRejectToStart && (this_.backHandMode =='normal' || !this_.rejectConf.inSubProcess)){
            this_.radio = "backToStart";
          }else if(!this_.rejectConf.afterGateway && !this_.rejectConf.inGateway && !this_.rejectConf.inSubProcess && this_.rejectConf.canRejectPreAct){
            this_.radio = "rejectPre";
          }else if(this_.rejectConf.canRejectToAnyNode && (!this_.rejectConf.inSubProcess || this_.backHandMode !='normal' )){
            this_.radio = "reject";
            this_.isNode = true;
          }
          this_.title = "驳回设置";
          this_.rejectDialog = true;
          this_.fullscreenLoading = false;
        });
    },
    //取消
    cancel() {
      this.rejectDialog = false;
    },
    //确认
    confirm() {
      if (!this.radio) {
        Message.warning("请选择驳回方式");
        return;
      }
      if (this.radio == "reject" && !this.nodeId) {
        Message.warning("请选择驳回节点");
        return;
      }
      if (!this.opinion && this.$refs.opinionText.getOpinion() == "") {
        Message.warning("请填写驳回意见");
        return;
      }
      utils.getOnlineFormData(false)
      .then(formDataStr => this.submitConfirm(formDataStr))
      .catch(reason =>
          utils.handleGetFormDataReject(reason).then(() => this.submitConfirm())
        );
    },
    submitConfirm(formDataStr) {
      if (formDataStr && formDataStr.constructor != String) {
        formDataStr = JSON.stringify(formDataStr);
      }
      if (this.radio == "rejectPre") {
        this.nodeId = "";
      }
      let files = "";
      if (this.$refs.fileUpload && this.$refs.fileUpload.getFiles() != "") {
        files = JSON.stringify(this.$refs.fileUpload.getFiles());
      }
      let data = {
        taskId: this.taskId,
        rejectTaskId:this.rejectTaskId,
        actionName: this.radio == "rejectPre" ? "reject" : this.radio,
        backHandMode: this.backHandMode,
        opinion: this.opinion || this.$refs.opinionText.getOpinion(),
        destination: this.nodeId,
        agentLeaderId: this.leaderId,
        files: files
      };
      if (window.urgentStateValue) {
        data.urgentStateValue = window.urgentStateValue;
      }
      if (formDataStr) {
        data.data = Base64.encode(formDataStr);
      }
      this.rejectSubmitLoading = true
      this.$store.dispatch("storeProcess/rejectComplete", data).then(() => {
        this.rejectSubmitLoading = false
        this.rejectDialog = false;
        if(window.ch){
          //浏览器的两个选项卡之间通讯 新窗口发送消息
          window.ch.postMessage("some data");
        }
        window.close();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.el-dialog__footer {
  padding: 10px 20px;
  padding-top: 10px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-table {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.form-table th {
  text-align: right;
  color: #666;
}

.form-table th > span {
  color: #f00;
}

.form-table th, .form-table td {
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.xh-star {
  color: red;
}
</style>